<app-globalpay></app-globalpay>
<app-nbgpay></app-nbgpay>
<app-rms></app-rms>
<app-apcopay #apcopayComponent></app-apcopay>
<app-trustpayment #trustpaymentComponent></app-trustpayment>
<app-jcc #jccComponent></app-jcc>
<app-cardlink #cardlinkComponent></app-cardlink>
<app-eurobank #eurobankComponent></app-eurobank>
<app-alphabank #alphabankComponent></app-alphabank>
